export class IncomingOutgoingMapper {}
